<label
  *ngIf='label'
  [for]='inputId'
  [innerHTML]='label'
  [ngClass]='{"fw-bold": fontWeightBold}'
></label>

<div class='input-image-container' style="background-color: #e9e9e9" *ngIf="!showImage">
  <div class='input-image'>
    <div class='opacity-box'></div>
    <div style='position: relative; width: 130px; height: 130px; background: #33333333;'></div>
  </div>
</div>

<div [id]='inputId' class='input-image-container' *ngIf="showImage">

  <div *ngIf='deletable' class='overlay-delete-button'>
    <button (click)='delete()' class='btn btn-danger btn-sm' type='button'>
      <pt-icon [key]='Trash'></pt-icon>
    </button>
  </div>

  <div (click)='changeFile.value = null; changeFile.click()'
       [ngClass]="{ 'input-image--editable': editable,
       'input-image--reseller': reseller, 'input-image--organization': !reseller}"
       [ngStyle]="{ 'background-image': 'url(' + selectedFile + ')'}"
       class='input-image'>
    <div class='opacity-box'></div>
    <img [src]='selectedFile' alt="" style='opacity: 0; position: relative; width: 150px; height: 150px'>
    <button class='btn btn-sm btn-link' style='position: absolute; text-align: center;'>
      <svg enable-background='new 0 0 24 24' fill='#f2f2f2'
           height='30' id='_x31_' viewBox='0 0 24 24'
           width='30' xmlns='http://www.w3.org/2000/svg'>
        <g>
          <path
            d='m17.453 24c-.168 0-.34-.021-.51-.066l-15.463-4.141c-1.06-.292-1.692-1.39-1.414-2.45l1.951-7.272c.072-.267.346-.422.612-.354.267.071.425.346.354.612l-1.95 7.27c-.139.53.179 1.082.71 1.229l15.457 4.139c.531.14 1.079-.176 1.217-.704l.781-2.894c.072-.267.346-.426.613-.353.267.072.424.347.353.613l-.78 2.89c-.235.89-1.045 1.481-1.931 1.481z'/>
        </g>
        <g>
          <path
            d='m22 18h-16c-1.103 0-2-.897-2-2v-12c0-1.103.897-2 2-2h16c1.103 0 2 .897 2 2v12c0 1.103-.897 2-2 2zm-16-15c-.551 0-1 .449-1 1v12c0 .551.449 1 1 1h16c.551 0 1-.449 1-1v-12c0-.551-.449-1-1-1z'/>
        </g>
        <g>
          <path
            d='m9 9c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-3c-.551 0-1 .449-1 1s.449 1 1 1 1-.449 1-1-.449-1-1-1z'/>
        </g>
        <g>
          <path
            d='m4.57 16.93c-.128 0-.256-.049-.354-.146-.195-.195-.195-.512 0-.707l4.723-4.723c.566-.566 1.555-.566 2.121 0l1.406 1.406 3.892-4.67c.283-.339.699-.536 1.142-.54h.011c.438 0 .853.19 1.139.523l5.23 6.102c.18.209.156.525-.054.705-.209.18-.524.157-.705-.054l-5.23-6.102c-.097-.112-.231-.174-.38-.174-.104-.009-.287.063-.384.18l-4.243 5.091c-.09.108-.221.173-.362.179-.142.01-.277-.046-.376-.146l-1.793-1.793c-.189-.188-.518-.188-.707 0l-4.723 4.723c-.097.097-.225.146-.353.146z'/>
        </g>
      </svg>
    </button>
<!--    <div class="resolution" [ngClass]="'is-valid'" *ngIf="isChanged">-->
<!--      {{'MESSAGE.SAVE_FOR_APPLY' | translate}}-->
<!--    </div>-->
  </div>
</div>
<input #changeFile (change)='onFileChanged($event)'
       accept='image/png, image/jpeg'
       class='d-none' type='file'>


<ng-template #dialog>
  <div class='modal-header'>
    <div>
      <h4 class='modal-title' id='modal-basic-title'>
        {{'TITLE.INPUT_IMAGE_ERROR_DIALOG' | translate}}
      </h4>
    </div>
    <button type='button' class='btn-close' aria-label='Close' (click)='closeDialog()'>
    </button>
  </div>

  <div class='modal-body'>
    <p [ngSwitch]='fileValidatorResponse?.error'>
      <ng-container *ngSwitchCase='"tooLargeFileError"'>
        {{'MESSAGE.INPUT_IMAGE_ERROR.TOO_LARGE_FILE_ERROR' | translate}}
      </ng-container>
      <ng-container *ngSwitchCase='"widthHeightFileError"'>
        {{'MESSAGE.INPUT_IMAGE_ERROR.WIGHT_HEIGHT_FILE_ERROR' | translate}}
      </ng-container>
      <ng-container *ngSwitchCase='"fileTypeError"'>
        {{'MESSAGE.INPUT_IMAGE_ERROR.FILE_TYPE_ERROR' | translate}}
      </ng-container>
      <ng-container *ngSwitchCase='"widthFileError"'>
        {{'MESSAGE.INPUT_IMAGE_ERROR.WIDTH_FILE_ERROR' | translate}}
      </ng-container>
      <ng-container *ngSwitchCase='"heightFileError"'>
        {{'MESSAGE.INPUT_IMAGE_ERROR.HEIGHT_FILE_ERROR' | translate}}
      </ng-container>
    </p>
    <p *ngIf="info" [innerHTML]="info"></p>
  </div>
</ng-template>
